var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page report-notarization"},[_c('Menus',{attrs:{"title":"办证指引","border":true}},[_c('a',{attrs:{"slot":"left-link","href":"javascript:void(0)"},on:{"click":_vm.goback},slot:"left-link"})]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-flex"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"report-container",attrs:{"id":"div_report"}})])])
}]

export { render, staticRenderFns }